import type { IconSvgObject } from './types';

const ArrowDownBigIcon: IconSvgObject = [
  ["path", { d: "M11.1598 20.1336L5.19186 13.7066C5.06854 13.5738 5 13.3993 5 13.218C5 12.8215 5.32148 12.5 5.71803 12.5H9V4.5C9 3.94772 9.44772 3.5 10 3.5H14C14.5523 3.5 15 3.94772 15 4.5V12.5H18.282C18.6785 12.5 19 12.8215 19 13.218C19 13.3993 18.9315 13.5738 18.8081 13.7066L12.8402 20.1336C12.6233 20.3672 12.3188 20.5 12 20.5C11.6812 20.5 11.3767 20.3672 11.1598 20.1336Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default ArrowDownBigIcon;
